import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import '../style.scss'
import { useParams } from 'react-router-dom';
import TableGridView from "../../TableGridView";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { Tooltip } from '@material-ui/core';
import { patientRequestsRequest } from '../../../store/requests/actions';
import moment from 'moment';
import RequestDetails from './RequestDetails';
import CancelForm from './CancelForm';

function PatientRequests({ intl: { messages }, setEditContact, disabled }) {
    const dispatch = useDispatch();
    const { patientRequests } = useSelector((state) => state.requests);
    const user = useSelector((state) => state.auth?.user?.data);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [showCancel, setShowCancel] = useState(false);
    const { id } = useParams();

    useEffect(() => {
       if (id) {
            dispatch(patientRequestsRequest({ patientId: id, sort: 'created_at,desc' }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    //table n grid view render
  const headings = [
    messages.patients.patient_requests.request_date,
    messages.patients.patient_requests.request_message,
    messages.patients.patient_requests.request_status,
    messages.patients.patient_requests.request_stage,
    messages.patients.patient_requests.action,
  ];

  //console.log(patientRequests);

  const renderTableData = () => {
    return patientRequests?.data?.map((request, i) => {
      const { created_at, message_text, stage, stage_name, request_status, request_status_name } =
        request;
      return [
        moment(created_at).format('DD MMMM YYYY'),
        <Tooltip title={message_text} placement="bottom">
          <span className="english_name">
            {message_text.length > 30 ? `${message_text.substring(0,25)}...` : message_text}
          </span>
        </Tooltip>,
        <span style={stage === 4 ? { color: '#C00' } : { color: '#000' }}>{stage_name}</span>,
        request_status_name,
        <div className="requests_actions">
          <button type='button' className='link' onClick={(e) => {
            e.preventDefault();
            setSelectedRequest(request);
            setShowDetails(true);
          }}>{messages.patients.patient_requests.details}</button>
          {user?.role_id < 4 && stage === 2 && (request_status < 6 || request_status > 12) ? <span onClick={(e) => {
            e.preventDefault();
            setSelectedRequest(request);
            setShowCancel(true);
          }}>{messages.patients.patient_requests.cancel_request}</span> : null}
        </div>,
      ];
    });
  };
  
    const handlePageChange = (e, page) => {
        return dispatch(
          patientRequestsRequest({
              page,
              patientId: id,
              sort: 'created_at,desc',
          })
        );
    };

    if (patientRequests?.data?.length > 0) {
      return (
        <div style={{ width: '100%', marginBottom: "20px" }} >
            {patientRequests ? (
              <TableGridView
                title={null}
                Form={null}
                table={{
                  stickyHeader: true,
                  headings: headings,
                  data: renderTableData(),
                  headClass: "bg-white table-head",
                  noData: messages.noData.no_data,
                }}
                pagination={{
                  count: patientRequests.last_page,
                  page: patientRequests.current_page,
                  handleChange: handlePageChange,
                }}
              />
            ) : null}
            <ConfirmDialog show={deleteConfirmation}
                    onCancel={() => setDeleteConfirmation(false)}
                    onConfirm={() => {
                      setDeleteConfirmation(false);
                    }}
                    icon={null}
                    content={messages.patients.form.deleteContact}
                    cancelBtn={messages.warningMsgs.cancel}
                    confirmBtn={messages.warningMsgs.confirm} />
            <RequestDetails show={showDetails} close={() => setShowDetails(false)} requestId={selectedRequest?.id} />
            <CancelForm show={showCancel} close={() => setShowCancel(false)} selectedRequest={selectedRequest?.id} patientId={id} />
          </div>
        );
    } else {
      return (
        <div className="no-data-block">
            {messages.patients.patient_requests.noData}
        </div>
      )
    }
}

export default injectIntl(PatientRequests)